<template>
  <section class="support-agent-card" aria-live="polite">
    <div class="support-agent-card__header">
      <span class="support-agent-card__badge">
        <v-icon small>mdi-account-headset</v-icon>
        Assistente de suporte
      </span>
      <span v-if="confidence" class="support-agent-card__confidence">
        confianca {{ confidence }}
      </span>
    </div>

    <div v-if="loading" class="support-agent-card__loading">
      Estou olhando o ambiente e o que voce escreveu...
    </div>

    <template v-else-if="analysis">
      <h3>{{ title }}</h3>
      <p v-if="message" class="support-agent-card__message">
        {{ message }}
      </p>

      <div v-if="links.length" class="support-agent-card__links">
        <v-btn
          v-for="link in links"
          :key="link.url"
          small
          outlined
          color="primary"
          :href="link.url"
          target="_blank"
          rel="noopener noreferrer"
        >
          <v-icon small left>mdi-open-in-new</v-icon>
          {{ link.principal ? "Abrir endereco sugerido" : link.titulo || "Abrir endereco" }}
        </v-btn>
        <small v-for="link in links" :key="`${link.url}-motivo`">
          <strong>{{ link.url }}</strong>
          {{ link.motivo }}
        </small>
      </div>

      <ol v-if="actions.length" class="support-agent-card__steps">
        <li v-for="item in actions" :key="item">{{ item }}</li>
      </ol>

      <div v-if="checklist.length" class="support-agent-card__checklist">
        <strong>Estou conferindo estes pontos:</strong>
        <ul>
          <li v-for="item in checklist" :key="item">{{ item }}</li>
        </ul>
      </div>

      <v-alert v-if="question" type="info" outlined dense class="mt-3 mb-0">
        {{ question }}
      </v-alert>

      <small v-if="protocol" class="support-agent-card__protocol">
        Atendimento inicial registrado: {{ protocol }}
      </small>
    </template>
  </section>
</template>

<script>
export default {
  name: "SupportAgentCard",
  props: {
    analysis: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    title() {
      return (
        (this.analysis && this.analysis.assistenteTitulo) ||
        "Vamos resolver antes de enviar ao suporte"
      );
    },
    message() {
      return (
        (this.analysis && this.analysis.assistenteMensagem) ||
        (this.analysis && this.analysis.causaProvavel) ||
        ""
      );
    },
    question() {
      return this.analysis && this.analysis.assistentePergunta;
    },
    confidence() {
      return this.analysis && this.analysis.confianca;
    },
    protocol() {
      return this.analysis && this.analysis.protocoloAtendimentoInicial;
    },
    actions() {
      if (!this.analysis) return [];
      return this.analysis.assistenteAcoes && this.analysis.assistenteAcoes.length
        ? this.analysis.assistenteAcoes
        : this.analysis.orientacao || [];
    },
    checklist() {
      return (this.analysis && this.analysis.assistenteChecklist) || [];
    },
    links() {
      return (this.analysis && this.analysis.linksSugeridos) || [];
    },
  },
};
</script>

<style lang="scss" scoped>
.support-agent-card {
  background: #ffffff;
  border: 1px solid #d7dde8;
  border-radius: 8px;
  padding: 14px;
  margin-top: 12px;
}

.support-agent-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.support-agent-card__badge {
  align-items: center;
  color: #1f2937;
  display: inline-flex;
  font-size: 12px;
  font-weight: 700;
  gap: 6px;
  letter-spacing: 0;
  text-transform: uppercase;
}

.support-agent-card__confidence {
  color: #667085;
  font-size: 12px;
}

h3 {
  color: #1f2937;
  font-size: 17px;
  line-height: 1.3;
  margin: 0 0 8px;
}

.support-agent-card__message {
  color: #344054;
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 10px;
}

.support-agent-card__loading {
  color: #344054;
  font-size: 14px;
}

.support-agent-card__links {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 10px 0 12px;

  small {
    color: #667085;
    line-height: 1.4;
    overflow-wrap: anywhere;

    strong {
      color: #344054;
      display: block;
      font-weight: 700;
      margin-bottom: 2px;
    }
  }
}

.support-agent-card__steps {
  color: #344054;
  font-size: 13px;
  line-height: 1.45;
  margin: 8px 0 0;
  padding-left: 20px;

  li {
    margin-bottom: 7px;
  }
}

.support-agent-card__checklist {
  background: #f8fafc;
  border: 1px solid #e5eaf2;
  border-radius: 8px;
  color: #344054;
  font-size: 13px;
  margin-top: 10px;
  padding: 10px 12px;

  strong {
    display: block;
    margin-bottom: 6px;
  }

  ul {
    margin: 0;
    padding-left: 18px;
  }

  li + li {
    margin-top: 4px;
  }
}

.support-agent-card__protocol {
  color: #667085;
  display: block;
  margin-top: 10px;
}
</style>
